import { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import { ProfessionalData } from "../../../../dto/profiledata/ProfileDataFormDTO";
import React from "react";
import { Combobox, ETypeOfNotification, InputTextCustom, Loader, setNotification } from "medere-ui-framework";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { Icon } from "@iconify/react/dist/iconify.js";
import { loadAdministrativesEnabledForPrescription, loadEnrollmentType, loadMedicalSpecialities } from "../../../../servicesHooks/DigitalRP/useDigitalRPService";
import { ComboDataDTO } from "../../../../dto/ComboDataDTO";
import { MedicalSpeciality, UserAllowedToPrescript } from "../../../../interface/interface";
import { useDispatch } from "react-redux";
import imageCompression from 'browser-image-compression';
import { loadSignature, uploadSignature } from "../../../../servicesHooks/ProfileDataForm/useProfileDataFormService";


interface ProfessionalTabProps {
    professionalData: ProfessionalData;
    setProfessionalData: (professionalData: ProfessionalData) => void;
    secretary: boolean;
    isProfessional: boolean;
    errors: Partial<Record<keyof ProfessionalData, boolean>>;
}

const imageCompressionOptions = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
};

export default function ProfessionalTab({ professionalData, setProfessionalData, secretary, isProfessional, errors }: ProfessionalTabProps) {
    const [allSpecialities, setAllSpecialities] = useState<MedicalSpeciality[]>([]);
    const [selectedSecretary, setSelectedSecretary] = useState<UserAllowedToPrescript>();
    const [selectedSpeciality, setSelectedSpeciality] = useState<MedicalSpeciality>();

    const dispatch = useDispatch();
    
    const [previousSignature, setPreviousSignature] = useState<string | null>(null);
    const [newSignature, setNewSignature] = useState<string | null>(null);
    const [loadingSignature, setLoadingSignature] = useState<boolean>(false);
    
    useEffect(() => {
            if(!isProfessional) return;
            loadSignature().then((response) => {setPreviousSignature(response);}).catch((error) => {console.error(error);});
        }, [isProfessional]);

    const handleSaveSecretary = () => {
        if (!selectedSecretary) return;
        if (professionalData.secretaries.some(secre => secre.medereentity === selectedSecretary.medereentity)) return;

        const secretaries: UserAllowedToPrescript[] = [...professionalData.secretaries, selectedSecretary];
        setProfessionalData({ ...professionalData, secretaries });
    };

    const handleDeleteSecretaries = (secre: UserAllowedToPrescript) => {
        const secretaries = [...professionalData.secretaries];

        if (!secre || secre?.insert) {
            const updated = secretaries.filter(item => item !== secre);
            setProfessionalData({ ...professionalData, secretaries: updated });
            return;
        }

        const index = secretaries.findIndex(item => item.medereentity === secre.medereentity);
        if (index === -1) return;

        secretaries[index] = { ...secretaries[index], delete: true };
        setProfessionalData({ ...professionalData, secretaries });
    };

    const handleAddSpeciality = () => {
        if (!selectedSpeciality) return;
        if (professionalData.specialities.some(s => s.medicalspeciality === selectedSpeciality.medicalspeciality)) return;

        const updated = [...professionalData.specialities, selectedSpeciality];
        setProfessionalData({ ...professionalData, specialities: updated });
    };

    const handleDeleteSpeciality = (spec: MedicalSpeciality) => {
        const updated = professionalData.specialities.filter(s => s.medicalspeciality !== spec.medicalspeciality);
        setProfessionalData({ ...professionalData, specialities: updated });
    };
    

    useEffect(() => {
        loadMedicalSpecialities().then((response) => {
            setAllSpecialities(response);
        });
    }, []);

    return (
        <React.Fragment>
            {!secretary && (
                <React.Fragment>
                    <div className="grid-row four-columns">
                        <div>
                            <Combobox
                                className={!errors.workenrollmenttype ? `white-component` : `blank-error-component`}
                                autocompleteClassName="combobox-border"
                                getItems={loadEnrollmentType}
                                optionLabel="name"
                                placeholder='Seleccionar'
                                value={professionalData.workenrollmenttype?.name}
                                setValue={(e: ComboDataDTO | null) => {
                                    if (e == null) return;
                                    setProfessionalData({ ...professionalData, workenrollmenttype: e });
                                }}
                                label='Tipo de matrícula'
                                required
                            />
                        </div>
                        <div>
                            <InputTextCustom
                                className={!errors.workenrollment ? `white-component` : `blank-error-component`}
                                spanClassName="combobox-border"
                                name="workenrollment"
                                value={professionalData.workenrollment}
                                onChange={(e) => setProfessionalData({ ...professionalData, workenrollment: e.target.value })}
                                label='N° de matrícula'
                                required
                            />
                        </div>
                        <div className="signature-upload-container" style={{ marginTop: '7px' }}>
                            <label className="file-label">Firma</label>
                            <div className="file-upload" onClick={() => document.getElementById('signatureInput').click()}>
                                <button className="upload-button">
                                    Tomar o cargar <span className="bold">firma</span>
                                </button>
                                <input
                                    id="signatureInput"
                                    type="file"
                                    accept="image/*"
                                    onChange={async (event) => {
                                        const file = event.target.files[0];
                                        if (!file) return;
                                        setLoadingSignature(true);
                                        try {
                                            const compressedFile = await imageCompression(file, imageCompressionOptions);
                                            if (compressedFile.size < 1048576) {
                                                uploadSignature(compressedFile).then(() => {
                                                    setNewSignature(URL.createObjectURL(compressedFile));
                                                    dispatch(setNotification({
                                                        title: "Firma actualizada correctamente",
                                                        icon: 'pi-check',
                                                        typeOfNotification: ETypeOfNotification.INFO
                                                    }));
                                                }).catch((error) => {
                                                    console.error(error);
                                                });
                                            } else {
                                                dispatch(setNotification({
                                                    title: "No pudimos cargar la firma",
                                                    desc: "Te pedimos por favor que selecciones una imagen de tamaño menor a 1MB",
                                                    icon: 'pi-times',
                                                    typeOfNotification: ETypeOfNotification.ERROR
                                                }));
                                            }
                                        } catch (error) {
                                            console.error('Error al comprimir la imagen:', error);
                                        }
                                        setLoadingSignature(false);
                                    }}
                                    style={{ display: 'none' }}
                                />
                                {loadingSignature ? (
                                    <Loader />
                                ) : (
                                    (newSignature || previousSignature) && (
                                        <img src={newSignature ?? previousSignature} alt="Firma" className="preview-image" />
                                    )
                                )}
                            </div>
                        </div>
                        <div className="complementary-text" style={{ marginTop: '7px' }}>
                            <label className="file-label">Texto complementario a firma</label>
                            <textarea
                                className="border2"
                                value={professionalData.signaturedata}
                                onChange={(e) => setProfessionalData({ ...professionalData, signaturedata: e.target.value })}
                                rows={3}
                                style={{ height: '45px' }}
                            />
                        </div>
                    </div>
                    <div className='grid-row two-columns'>
                        {/* Especialidades asignadas */}
                        <div style={{ boxShadow: '0 4px 4px rgba(0,0,0,0.15)', alignSelf: 'flex-start' }} className="collapsible-card">
                            <div className='content-header'>
                                <div className="header">
                                    <div style={{ color: '#B27668' }} className="title">Especialidades asignadas</div>
                                </div>
                            </div>
                            <div className="content">
                                <div style={{ marginBottom: '-1rem', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <Combobox
                                        className="border2 mb-4 white-component"
                                        getItems={loadMedicalSpecialities}
                                        optionLabel='name'
                                        placeholder='Seleccionar'
                                        value={selectedSpeciality}
                                        setValue={setSelectedSpeciality}
                                    />
                                    <div style={{ paddingLeft: '10px' }}>
                                        <Button
                                            className='circbtn'
                                            style={{ background: 'none', border: 'none', padding: '0px', borderRadius: '20px', marginTop: '12px' }}
                                            onClick={handleAddSpeciality}
                                        >
                                            <Icon icon='bi:plus' style={{ color: '#01717C', fontSize: '30px', padding: '3px', marginBottom: '20px', backgroundColor: '#ECECEC', borderRadius: '100%' }} />
                                        </Button>
                                    </div>
                                </div>

                                {professionalData.specialities?.filter((spec) => !spec?.delete).map((spec, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            borderTop: '0.1px solid #A9B1BC',
                                            borderBottom: index === professionalData.specialities.length - 1 ? '0.1px solid #A9B1BC' : '',
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'space-between'
                                        }}
                                    >
                                        <div style={{ fontSize: '13px', fontWeight: 600, display: 'flex', flexDirection: 'column', marginTop: '10px' }}>
                                            <span>{spec?.name}</span>
                                        </div>
                                        <div>
                                            <Button style={{ color: '#3CB8BA', background: 'none', border: 'none', fontWeight: 600 }} onClick={() => handleDeleteSpeciality(spec)}>
                                                <Icon icon='bi:x' style={{ color: '#3CB8BA', fontSize: '25px' }} />
                                            </Button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Secretarias asignadas */}
                        <div style={{ boxShadow: '0 4px 4px rgba(0,0,0,0.15)', alignSelf: 'flex-start' }} className="collapsible-card">
                            <div className='content-header'>
                                <div className="header">
                                    <div style={{ color: '#B27668' }} className="title">Secretarias asignadas</div>
                                </div>
                            </div>
                            <div className="content">
                                <div style={{ marginBottom: '-1rem', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <Combobox
                                        className="border2 mb-4 white-component"
                                        getItems={loadAdministrativesEnabledForPrescription}
                                        optionLabel='fulldescription'
                                        placeholder='Seleccionar'
                                        value={selectedSecretary}
                                        setValue={setSelectedSecretary}
                                    />
                                    <div style={{ paddingLeft: '10px' }}>
                                        <Button
                                            className='circbtn'
                                            style={{ background: 'none', border: 'none', padding: '0px', borderRadius: '20px', marginTop: '12px' }}
                                            onClick={handleSaveSecretary}
                                        >
                                            <Icon icon='bi:plus' style={{ color: '#01717C', fontSize: '30px', padding: '3px', marginBottom: '20px', backgroundColor: '#ECECEC', borderRadius: '100%' }} />
                                        </Button>
                                    </div>
                                </div>

                                {professionalData.secretaries?.filter((secre) => !secre?.delete).map((secre, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            borderTop: '0.1px solid #A9B1BC',
                                            borderBottom: index === professionalData.secretaries.length - 1 ? '0.1px solid #A9B1BC' : '',
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'space-between'
                                        }}
                                    >
                                        <div style={{ fontSize: '13px', fontWeight: 600, display: 'flex', flexDirection: 'column', marginTop: '10px' }}>
                                            <span>{secre?.fulldescription}</span>
                                        </div>
                                        <div>
                                            <Button style={{ color: '#3CB8BA', background: 'none', border: 'none', fontWeight: 600 }} onClick={() => handleDeleteSecretaries(secre)}>
                                                <Icon icon='bi:x' style={{ color: '#3CB8BA', fontSize: '25px' }} />
                                            </Button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            )}

            {/* Checkboxes */}
                <div className="checkbox-item" style={{ marginTop: '10px' }}>
                    <Checkbox inputId="concurrentLocations" checked={professionalData.concurrentlocations} onChange={(e) => setProfessionalData({ ...professionalData, concurrentlocations: e.checked })} />
                    <label htmlFor="concurrentLocations"> Atención en locaciones concurrentes</label>
                </div>
                <div className="checkbox-item" style={{ marginTop: '10px' }}>
                    <Checkbox inputId="receivePrescriptions" checked={professionalData.receiveprescriptions} onChange={(e) => setProfessionalData({ ...professionalData, receiveprescriptions: e.checked })} />
                    <label htmlFor="receivePrescriptions"> Recibe pedidos de recetas de pacientes</label>
                </div>
        </React.Fragment>
    );
}
